import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'react-toastify';
import { FiMail, FiLock, FiEye, FiEyeOff } from 'react-icons/fi';
import './Login.css';
import { Link } from 'react-router-dom';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const result = await login(formData.email, formData.password);
      
      if (result.success) {
        toast.success('Login successful!');
        navigate('/dashboard');
      } else {
        toast.error(result.error || 'Login failed');
      }
    } catch (error) {
      toast.error('An error occurred during login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-background">
        <div className="login-card">
          <div className="login-header">
            <div className="logo-container">
              <Link to="/dashboard" className="logo">
                <svg xmlns="http://www.w3.org/2000/svg" width="98" height="29.485" viewBox="0 0 98 29.485">
                  <g transform="translate(-52 -39.515)">
                    <g transform="translate(-403 -140)">
                      <rect className="logo-square" width="12" height="12" rx="3" transform="translate(455 182)"></rect>
                      <rect className="logo-square" width="12" height="12" rx="3" transform="translate(455 197)"></rect>
                      <rect className="logo-square" width="12" height="12" rx="3" transform="translate(476 179.515) rotate(45)"></rect>
                      <rect className="logo-square" width="12" height="12" rx="3" transform="translate(470 197)"></rect>
                    </g>
                  </g>
                </svg>
              </Link>
            </div>
            <h1>Welcome Back</h1>
            <p>Sign in to your account to continue</p>
          </div>

          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <div className="input-wrapper">
                <FiMail className="input-icon" />
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email Address"
                  required
                  className="form-input"
                />
              </div>
            </div>

            <div className="form-group">
              <div className="input-wrapper">
                <FiLock className="input-icon" />
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Password"
                  required
                  className="form-input"
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FiEyeOff /> : <FiEye />}
                </button>
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="login-button"
            >
              {loading ? 'Signing In...' : 'Sign In'}
            </button>
          </form>

          <div className="forgot-password">
            <p>Forgot your password? <a href="/forgot-password">Click here</a> to recover now.</p>
          </div>

          <div className="login-footer">
            <p className="demo-credentials">
              <strong>Demo Credentials:</strong><br />
              Email: test@chromi.us<br />
              Password: 123456
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login; 